import React, { useState } from 'react';
import StockInService from '../../services/stockInService';

/**
 * Bill Memory (Fix plan, I4): after a Wrong, "Revert this line" — today's selective revert of that one stock-in
 * line (the stock it added comes back out; Bill Memory takes back what it taught). Nothing to revert → nothing drawn.
 */
export default function RevertLineButton({ revert }) {
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);
  if (!revert || !revert.stockInId || !revert.lineItemId) return null;
  const go = async () => {
    setBusy(true);
    setMsg('');
    try {
      await StockInService.revertStockIn(revert.stockInId, [revert.lineItemId]);
      setMsg('Line reverted.');
    } catch (e) {
      setMsg((e && e.message) || 'Could not revert this line. Revert it from Stock In instead.');
    } finally {
      setBusy(false);
    }
  };
  if (msg === 'Line reverted.') return <span className="bm-note">{msg}</span>;
  return (
    <span>
      <button type="button" className="irr-secondary-btn" disabled={busy} onClick={go}>Revert this line</button>
      {msg && <span className="bm-note">{` ${msg}`}</span>}
    </span>
  );
}
